import { render, staticRenderFns } from "./CollectionLog.vue?vue&type=template&id=c00a5450&"
import script from "./CollectionLog.vue?vue&type=script&lang=js&"
export * from "./CollectionLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports